import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "../../lib/utils.js";

// A native range input on the brand accent. Native keeps keyboard, touch and
// screen-reader support for free; this only gives it the app's look.
const rangeSliderVariants = cva(
  "w-full cursor-pointer appearance-auto accent-brand-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 focus-visible:ring-offset-2 focus-visible:ring-offset-surface-0 disabled:cursor-not-allowed disabled:opacity-50",
  {
    variants: {
      size: {
        sm: "h-1.5",
        default: "h-2",
      },
    },
    defaultVariants: { size: "default" },
  }
);

export interface RangeSliderProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "type" | "size" | "value" | "onChange">,
    VariantProps<typeof rangeSliderVariants> {
  value: number;
  onValueChange: (value: number) => void;
}

export const RangeSlider = React.forwardRef<HTMLInputElement, RangeSliderProps>(
  ({ className, size, value, onValueChange, ...props }, ref) => (
    <input
      ref={ref}
      type="range"
      value={value}
      onChange={e => onValueChange(Number(e.target.value))}
      className={cn(rangeSliderVariants({ size }), className)}
      {...props}
    />
  )
);
RangeSlider.displayName = "RangeSlider";
